// ListPatientsWrapper.js
import React from 'react';
import { useLocation } from 'react-router-dom';
import ListPatients from './ListPatients';
import useAuth from "../hooks/useAuth";
import { useNavigate } from 'react-router-dom';
const ListPatientsWrapper = () => {
  const location = useLocation();
  const auth = useAuth();
  const navigate = useNavigate();
  return <ListPatients location={location}  auth={auth} navigate={navigate} />;
};

export default ListPatientsWrapper;
